/**
 * define dependencies for external assets here
 * (e.g. for showing icons in slack)
 * should be emitted as assets under /static/media/[filename].[hash].[ext]
 **/
export * from "./Confluence_Slack.png";
export * from "./Notion_Slack.png";
